import api from '../api';

import { ParamsBodyValidateDocument, ParamsDataValidateDocument } from 'utils/typeServices';

type ParamsResponse = {
    Data: ParamsDataValidateDocument;
}

export const PostValidateDocument = async (body: ParamsBodyValidateDocument) => {
    const bodyJson = JSON.stringify({ Document: body.document.replace(/[^0-9A-Z.\/\-]/g, '') });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Cliente/ValidateDocument', bodyJson);

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
